// src/shared/constants/api.ts

export const API_DEFAULT_PAGE_SIZE = 20;

export const API_PAGE_SIZE_OPTIONS = [10, 20, 50, 100];
